import Vue from 'vue';
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);
